// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3ul5Y","icon":"styles_icon__7F6s6"};